import React, { Fragment } from 'react';
import AvatarEditor from 'react-avatar-editor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil';
import { faExpand } from '@fortawesome/pro-light-svg-icons/faExpand';
import { faPalette } from '@fortawesome/pro-light-svg-icons/faPalette';
import classnames from 'classnames';
import { ChromePicker } from 'react-color';
import CircleShadow from './Buttons/CircleShadow';
import DragDropGuide from './DragDropGuide';
import { guessImageBackgroundColor, fillImageWithColor } from '../../utils/guessImageColor';

const EditorStates = {
  Normal: 'normal',
  Editing: 'editing',
};

class AvatarSelector extends React.Component {
  state = {
    selectedImage: null,
    editorState: EditorStates.Normal,
    imgScale: 0.5,
    averageColor: null,
    colorPickerColor: null,
    errorImage: false,
  };

  handleImageChange = (event) => {
    const avatarMaxSize = 4194304;
    const { onError, t } = this.props;
    if (!event.target.files) {
      this.setState({ selectedImage: null, editorState: EditorStates.Normal });
      return;
    }
    const file = event.target.files[0];

    if (!file.type) {
      return;
    }

    const pattern = /image\/jpeg|image\/png/;
    if (!file.type.match(pattern)) {
      onError(t('errorInvalidFileExtension'));
      return;
    }

    if (file.size >= avatarMaxSize) {
      onError(t('errorInvalidFileSize'));
      return;
    }

    const selectedImage = file;
    this.setState({ selectedImage, editorState: EditorStates.Editing });
  };

  handleConfirmImage = async () => {
    const { onSelectImage } = this.props;
    const { imgScale, averageColor } = this.state;
    const image = imgScale < 1 ? await fillImageWithColor(this.avatarEditor.getImage().toDataURL(), averageColor) : this.avatarEditor.getImage().toDataURL();
    await onSelectImage(image);
    this.setState({ editorState: EditorStates.Normal, showColorPicker: false });
    this.fileElement.value = '';
  };

  cancelEdition = () => {
    this.setState({ selectedImage: null, editorState: EditorStates.Normal, showColorPicker: false });
    this.fileElement.value = '';
  };

  onLoadImage = async (e) => {
    this.selectedImageResource = e;
    const averageColor = await guessImageBackgroundColor(e.resource);
    this.setState({ averageColor, showColorPicker: false, colorPickerColor: averageColor });
  };

  resizeImage = () => {
    const { imgScale } = this.state;
    switch (imgScale) {
      case 1:
        this.setState({ imgScale: 2 });
        break;
      case 2:
        this.setState({ imgScale: 3 });
        break;
      case 3:
        this.setState({ imgScale: 0.5 });
        break;
      case 0.5:
        this.setState({ imgScale: 1 });
        break;
      default:
    }
  };

  toggleChangeColor = () => {
    const { showColorPicker } = this.state;
    this.setState({ showColorPicker: !showColorPicker });
  };

  onColorChange = (color) => {
    this.setState({ averageColor: color.hex, colorPickerColor: color.hex });
  };

  render() {
    const { selectedImage, editorState, errorImage, imgScale, averageColor, showColorPicker, colorPickerColor } = this.state;
    const {
      image,
      isLoading,
      letter,
      style,
      avatarStyle = {
        width: '128px',
        height: '126px',
        position: 'relative',
        top: '-40px',
        left: '-15px',
      },
      radius = 100,
    } = this.props;
    const classes = classnames('avatar-selector', { editing: editorState === EditorStates.Editing });
    const rootStyle = averageColor ? { background: averageColor } : { background: 'transparent' };
    return (
      <Fragment>
        <div style={{ ...rootStyle, ...style }} className={classes}>
          {isLoading ? (
            <div className="avatar-loading lds-ellipsis">
              <div />
              <div />
              <div />
              <div />
            </div>
          ) : null}
          <input
            style={{ display: 'none' }}
            type="file"
            ref={(ref) => {
              this.fileElement = ref;
            }}
            onChange={this.handleImageChange}
          />

          {editorState !== EditorStates.Editing ? (
            <img
              src={`${image}`}
              alt=""
              onError={() => this.setState({ errorImage: true })}
              onLoad={() => this.setState({ errorImage: false })}
              style={{ display: errorImage ? 'none' : '' }}
            />
          ) : null}
          {errorImage ? <div className="avatar-letter">{letter}</div> : null}
          {editorState === EditorStates.Editing ? (
            <AvatarEditor
              ref={(ref) => {
                this.avatarEditor = ref;
              }}
              image={selectedImage}
              style={avatarStyle}
              borderRadius={radius}
              color={[247, 247, 247, 1]} // RGBA
              scale={imgScale}
              rotate={0}
              disableHiDPIScaling
              onLoadSuccess={this.onLoadImage}
            />
          ) : null}
          <CircleShadow className="upload" onClick={() => this.fileElement.click()}>
            <FontAwesomeIcon icon={faPencil} />
          </CircleShadow>
          <Fragment>
            <CircleShadow className="confirm" darkMode onClick={this.handleConfirmImage}>
              <FontAwesomeIcon icon={faCheck} />
            </CircleShadow>
            <CircleShadow className="cancel" darkMode onClick={this.cancelEdition}>
              <FontAwesomeIcon icon={faTimes} />
            </CircleShadow>
            <CircleShadow className="resize" darkMode onClick={this.resizeImage}>
              <FontAwesomeIcon icon={faExpand} />
            </CircleShadow>
            <CircleShadow className="color" darkMode onClick={this.toggleChangeColor}>
              <FontAwesomeIcon icon={faPalette} />
            </CircleShadow>
          </Fragment>
          {/* <span>Cancelar</span> */}
        </div>
        {editorState === EditorStates.Editing && <DragDropGuide />}
        <div className="color-picker-area">{showColorPicker && <ChromePicker color={colorPickerColor} onChange={this.onColorChange} />}</div>
      </Fragment>
    );
  }
}

export default AvatarSelector;
